<template>
    <b-container fluid>
        <b-row class="justify-content-between flex-center py-2">
            <b-col cols="12" md="6" class="w-100">
                <h3>{{ $t('sales.users.title') }}</h3>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
                <b-input-group class="w-100 my-2" :prepend="$t('ticket_scan.button')">
                    <b-form-input type="text" v-model="searchText"></b-form-input>
                    <b-input-group-append>
                        <b-btn><span class="fa fa-search"></span></b-btn>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>

        <hr/>

        <!-- <b-row class="w-100 noMargin">
            <b-col cols="12" md="4" class="eventDash p-4" v-for="user in filterItems" @click="goToUser(user.id)" v-b-popover.hover.right="$t('hover.msg')">
                <h5 class="text-center"> {{ user.username }} </h5>
                <h6> {{ user.email }} </h6>
                <hr style="background-color:#FFF;"/>
                <h6> {{ $t('sales.users.total') }}: {{ user.total_assignments }} </h6>

            </b-col>
        </b-row> -->
        <b-container fluid class="p-2">
        <b-row class="w-100 noMargin noPadding justify-content-center">
            <b-col cols="12" md="3" class="eventDash m-2 p-4 shadow-lg" v-for="user in filterItems" @click="goToUser(user.id)" v-b-popover.hover.right="$t('hover.msg')">
                <b-row style="margin-bottom: 5%">
                    <b-col cols="6"><h6 class="text-left"> {{ user.username.toUpperCase() }} </h6></b-col>
                    <b-col cols="6"><b-badge pill style="color: white"  variant="warning" class="float-right">{{ $t('sales.users.total') }}: {{ user.total_assignments }}</b-badge></b-col>
                </b-row>
                <!-- <p class="text-right" style="background: rgb(97, 144, 231)"> {{ event.date | moment('DD.MM.YYYY') }} </p> -->
                
                <!-- <hr style="background-color:#FFF;"/> -->
                 <b-row>
                    <b-col cols="9">
                        <h4  v-b-popover.hover.left="$t('sales.sold')">{{user.tickets_sold}}</h4>
                        <p v-b-popover.hover.left="$t('sales.total')" style="color: grey">{{user.tickets_assigned}}</p>
                    </b-col>
                    <b-col cols="3" style="color: grey"><p>{{calculatePercentage(user.tickets_sold, user.tickets_assigned)}} %</p></b-col>
                </b-row>
                <b-progress :value="calculatePercentage(user.tickets_sold, user.tickets_assigned)" variant="warning" striped :animated="animate" class="mt-2"></b-progress>
            </b-col> 
        </b-row>
    </b-container>
    </b-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'users',
        data() {
            return {
                animate:true,
                users: null,
                usersFields: [
                    {
                        key: 'username',
                        label: 'Username',
                        sortable: true
                    },
                    {
                        key: 'email',
                        label: 'E-mail',
                        sortable: true
                    },
                ],
                searchText: "",
            }
        },
        computed: {
            filterItems() {
                if (this.users) {
                    return this.users.filter(item => {
                        return item['username'].toLowerCase().includes(this.searchText.toLowerCase());
                    });
                } else {
                    return this.users;
                }
            },
            
        },
        methods: {
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            goToUser (id){
                this.$router.push('/sales/' + this.$route.params.event_id + '/' + id)
            },
            calculatePercentage(sold, total){
                if(sold == 0 || total == 0){
                    return 0;
                }
                return parseInt((sold/total)*100);
            },
        },

        created() {
            this.$axios.get('sales/users',{
                                params: {
                                    event_id: this.$route.params.event_id
                                }
                            }).then(response => {
                if (response.data.success) {
                    this.users = response.data.data;
                }
            })
        },
    };
</script>
